import { render, staticRenderFns } from "./LoginConsent.vue?vue&type=template&id=3481d0fe&scoped=true"
import script from "./LoginConsent.vue?vue&type=script&lang=js"
export * from "./LoginConsent.vue?vue&type=script&lang=js"
import style0 from "./LoginConsent.vue?vue&type=style&index=0&id=3481d0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3481d0fe",
  null
  
)

export default component.exports